export default {
	"item.ATotalOf12MonthsAOneTimePurchaseOfTheAnnualReadingPlanWithNoFollowUpFees": "A total of 12 months, a one-time purchase of the Annual Reading Plan with no follow-up fees",
	"item.SubscribeToTheProductDetailPageYourself": "Subscribe to the product detail page yourself",
	"item.SelfSubscribedProductDetailPageBUYButton": "Self-subscribed product detail page_BUY button",
	"item.TheNameOfThePaymentMethodSelected": "The name of the payment method selected",
	"item.YouExistForAnActivatedCourse": "You exist for an activated course",
	"item.SorryTheVerificationFailed": "Sorry, the verification failed!",
	"item.MostRecentIssueStartDate": "Most recent issue start date:",
	"item.month": "month",
	"item.day": "day",
	"item.ConsecutiveSeasons": "Consecutive seasons",
	"item.quarter": "/quarter",
	"item.50OffPerSeason": "50% off per season",
	"item.YearRoundPurchases": "Year-round purchases",
	"item.500OffForTheWholeYear": "500% off for the whole year",
	"item.BuyNow": "Buy now"
}